// extracted by mini-css-extract-plugin
export default {"Gear":"Gear_Gear__wWntt"};